import React, { useEffect, useState, useCallback } from "react";
import ArrowUp from "@assets/icons/arrowup.svg";
import "@ui/components/scroll-to-top/scroll-to-top.css";
import { useI18n } from "@core/i18n/i18n";

const THRESHOLD_PX = 600;

interface ScrollToTopProps {
    inline?: boolean;
}

export const ScrollToTop: React.FC<ScrollToTopProps> = ({ inline = false }) => {
    const [visible, setVisible] = useState(false);
    const { format } = useI18n();

    const onScroll = useCallback(() => {
        const y = window.scrollY || window.pageYOffset;
        setVisible(y > THRESHOLD_PX);
    }, []);

    useEffect(() => {
        onScroll();
        window.addEventListener("scroll", onScroll, { passive: true });
        return () => window.removeEventListener("scroll", onScroll);
    }, [onScroll]);

    const handleClick = () => {
        if (typeof window !== "undefined") {
            const prefersReduced = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
            window.scrollTo({ top: 0, behavior: prefersReduced ? "auto" : "smooth" });
        }
    };
    
    const isVisible = visible;
    const classNames = ["scroll-to-top", isVisible ? "visible" : "", inline ? "vertical" : ""].join(" ").trim();

    return (
        <button
            className={classNames}
            onClick={handleClick}
            aria-label={format("global.scrollToTop")}
            aria-hidden={!isVisible}
            type="button"
        >
            <div className="arrow-wrap">
                <ArrowUp aria-hidden="true" />
            </div>
            <div className="label-wrap">
                <span className="scroll-label">{format("global.scrollToTop")}</span>
            </div>
        </button>
    );
};

export default ScrollToTop;
